import { render, staticRenderFns } from "./DropzoneForm.vue?vue&type=template&id=35834822"
import script from "./DropzoneForm.vue?vue&type=script&lang=js"
export * from "./DropzoneForm.vue?vue&type=script&lang=js"
import style0 from "./DropzoneForm.vue?vue&type=style&index=0&id=35834822&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports